import React from 'react';
import { Link } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';

import i18n from '../../../../i18n';
import { LoadingPage } from '../../../../components/LoadingPage';
import { ErrorView } from '../../../../components/ErrorView';
import { WarningCircle } from 'phosphor-react';
import moment from 'moment';

const QUERY = gql`
  query {
    importify {
      uploads {
        slug
        name
        status
        created
        numberOfRows
      }
    }
  }
`

export function ImportUploadsPage() {
  return <ImportUploads />
}

export function ImportUploads({
}) { 
  const { data, loading } = useQuery(QUERY)
  
  if (loading) {
    return <LoadingPage />
  }
  if (!data) {
    return <ErrorView />
  }
  const uploads = data?.importify?.uploads
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <table style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th></th>
                  <th>{i18n.t('Upload')}</th>
                  <th>{i18n.t('Status')}</th>
                  <th>{i18n.t('view')}</th>
                  <th>{i18n.t('number-of-leads')}</th>
                  <th>{i18n.t('created')}</th>
                </tr>
              </thead>
              <tbody>
                {uploads.map(upload => (
                  <tr style={{ backgroundColor: upload?.numberOfRows < 10 ? 'rgba(255, 0, 0, .1)' : 'default' }}>
                    <td>{upload?.numberOfRows < 1 && <WarningCircle color="red" />}</td>
                    <td><Link to={`/dashboard/upload/${upload.slug}`}>{upload.name}</Link></td>
                    <td>{i18n.t(upload.status)}</td>
                    <td><Link to={`/dashboard/discover?uploadId=${upload.slug}`}>View leads</Link></td>
                    <td style={{ textAlign: 'right' }}>{upload.numberOfRows?.toLocaleString(undefined, { miniumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                    <td>{moment(upload.created).format('YYYY-MM-DD')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default ImportUploadsPage